"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _range = _interopRequireDefault(require("lodash/range"));

var _reactSpring = require("react-spring");

var _reactI18next = require("react-i18next");

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));

var _Lens = _interopRequireDefault(require("@material-ui/icons/Lens"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _Button = _interopRequireDefault(require("../Button"));

var _Image = _interopRequireWildcard(require("../Image"));

var _carousel = require("../../hooks/carousel");

require("./index.css");

var Onboarding = function Onboarding(_ref) {
  var email = _ref.email,
      onFinish = _ref.onFinish,
      open = _ref.open;

  if (!open) {
    return null;
  }

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _email$split = email.split('@'),
      _email$split2 = (0, _slicedToArray2["default"])(_email$split, 2),
      name = _email$split2[0],
      domain = _email$split2[1];

  var pages = [function (_ref2) {
    var key = _ref2.key,
        style = _ref2.style;
    return /*#__PURE__*/_react["default"].createElement(ImageStage, {
      key: key,
      style: style,
      title: t('onboarding.welcome.0.title'),
      subtitle: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.0.subtitle.0')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        i18key: "onboarding.welcome.0.subtitle.1"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "inline-block truncate align-top text-primary",
        style: {
          maxWidth: '15rem'
        }
      }, name), /*#__PURE__*/_react["default"].createElement("span", {
        className: "inline-block align-baseline text-primary"
      }, "@", domain), ' ', "is ready to use!"))),
      image: /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        style: {
          height: 350,
          width: 600
        },
        src: (0, _Image.withThemeSrc)(t('welcome-0.png'), t('welcome-0-dark.png')),
        alt: t('onboarding.welcome.0.image.alt')
      }),
      bottom: /*#__PURE__*/_react["default"].createElement(ProgressDots, {
        current: index,
        total: pages.length
      })
    });
  }, function (_ref3) {
    var key = _ref3.key,
        style = _ref3.style;
    return /*#__PURE__*/_react["default"].createElement(ImageStage, {
      key: key,
      style: style,
      title: t('onboarding.welcome.1.title'),
      subtitle: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.1.subtitle.0')), /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.1.subtitle.1'))),
      image: /*#__PURE__*/_react["default"].createElement(Video, {
        src: (0, _Image.withThemeSrc)(t('welcome-1.mp4'), t('welcome-1-dark.mp4'))
      }),
      bottom: /*#__PURE__*/_react["default"].createElement(ProgressDots, {
        current: index,
        total: pages.length
      })
    });
  }, function (_ref4) {
    var key = _ref4.key,
        style = _ref4.style;
    return /*#__PURE__*/_react["default"].createElement(ImageStage, {
      key: key,
      style: style,
      title: t('onboarding.welcome.2.title'),
      subtitle: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.2.subtitle.0')), /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.2.subtitle.1'))),
      image: /*#__PURE__*/_react["default"].createElement(Video, {
        src: (0, _Image.withThemeSrc)(t('welcome-2.mp4'), t('welcome-2-dark.mp4'))
      }),
      bottom: /*#__PURE__*/_react["default"].createElement(ProgressDots, {
        current: index,
        total: pages.length
      })
    });
  }, function (_ref5) {
    var key = _ref5.key,
        style = _ref5.style;
    return /*#__PURE__*/_react["default"].createElement(ImageStage, {
      key: key,
      style: style,
      title: t('onboarding.welcome.3.title'),
      subtitle: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.3.subtitle.0')), /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.3.subtitle.1'))),
      image: /*#__PURE__*/_react["default"].createElement(Video, {
        src: (0, _Image.withThemeSrc)(t('welcome-3.mp4'), t('welcome-3-dark.mp4'))
      }),
      bottom: /*#__PURE__*/_react["default"].createElement(ProgressDots, {
        current: index,
        total: pages.length
      })
    });
  }, function (_ref6) {
    var key = _ref6.key,
        style = _ref6.style;
    return /*#__PURE__*/_react["default"].createElement(ImageStage, {
      key: key,
      style: style,
      title: t('onboarding.welcome.4.title'),
      subtitle: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.4.subtitle.0')), /*#__PURE__*/_react["default"].createElement("p", null, t('onboarding.welcome.4.subtitle.1'))),
      image: /*#__PURE__*/_react["default"].createElement(Video, {
        src: (0, _Image.withThemeSrc)(t('welcome-4.mp4'), t('welcome-4-dark.mp4'))
      }),
      bottom: /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: onFinish,
        color: "primary",
        className: "w-32"
      }, t('onboarding.welcome.finish'))
    });
  }];

  var _useCarousel = (0, _carousel.useCarousel)(pages.length),
      index = _useCarousel.index,
      next = _useCarousel.next,
      prev = _useCarousel.prev,
      transitions = _useCarousel.transitions;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 z-50 flex items-center justify-center w-full h-full",
    style: {
      background: 'rgba(0, 0, 0, 0.5)'
    }
  }, /*#__PURE__*/_react["default"].createElement(PaginationAction, {
    onClick: prev,
    disabled: index === 0,
    className: "mr-3"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center h-full",
    style: {
      width: 700
    }
  }, transitions.map(function (_ref7) {
    var item = _ref7.item,
        props = _ref7.props,
        key = _ref7.key;
    var stage = pages[item];
    return stage({
      key: key,
      style: props
    });
  })), /*#__PURE__*/_react["default"].createElement(PaginationAction, {
    onClick: next,
    disabled: index >= pages.length - 1,
    className: "ml-3"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowForward["default"], null)));
};

function ImageStage(_ref8) {
  var style = _ref8.style,
      title = _ref8.title,
      subtitle = _ref8.subtitle,
      image = _ref8.image,
      bottom = _ref8.bottom;
  return /*#__PURE__*/_react["default"].createElement(_reactSpring.a.div, {
    className: "image-stage",
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full text-center"
  }, image, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-4xl font-bold text-dark"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xl font-light"
  }, subtitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-16 mt-5"
  }, bottom)));
}

function PaginationAction(_ref9) {
  var className = _ref9.className,
      onClick = _ref9.onClick,
      children = _ref9.children,
      disabled = _ref9.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('h-full flex items-center', {
      invisible: disabled
    }, className)
  }, /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
    disableRipple: true,
    disableFocusRipple: true,
    component: "div",
    onClick: onClick,
    disabled: disabled
  }, children));
}

function ProgressDots(_ref10) {
  var current = _ref10.current,
      total = _ref10.total;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-full w-full items-center justify-center"
  }, (0, _range["default"])(total).map(function (i) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: i,
      className: (0, _classnames["default"])('mx-2 text-xs text-primary', {
        'opacity-25': i > current
      })
    }, /*#__PURE__*/_react["default"].createElement(_Lens["default"], {
      style: {
        fontSize: '1rem'
      }
    }));
  }));
}

function Video(props) {
  var src = (0, _Image.useThemeSrc)(props.src);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: 350,
      width: 600
    }
  }, /*#__PURE__*/_react["default"].createElement("video", {
    width: "100%",
    height: "auto",
    autoPlay: true,
    loop: true,
    muted: true
  }, /*#__PURE__*/_react["default"].createElement("source", {
    src: src,
    type: "video/mp4"
  }), "Your browser does not support the video tag."));
}

var _default = Onboarding;
exports["default"] = _default;
//# sourceMappingURL=index.js.map